export default __webpack_public_path__ + "assets/ico_back-1aff385b.svg";